import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SignalRService } from '../../../../services/signal-r/signal-r.service';
import { SignalRAction } from '../../../../services/signal-r/signalr-enums';
import * as AcceleratorCatalogActions from './accelerator-catalog.actions';
import { Channels } from 'src/app/store/channels';
import { GeneralSignalRResponse } from '../../../../services/signal-r/general-signal-r-response';

@Injectable({
    providedIn: 'root',
})
export class AcceleratorCatalogStoreAndListenersService {
    constructor(
        private store: Store,
        private signalRService: SignalRService,
    ) { }

    initStore() {
        this.store.dispatch(new AcceleratorCatalogActions.AcceleratorCatalogRefresh());
    }

    initListeners() {
        this.signalRService.hubConnection?.on(
            Channels.ACCELERATORCATALOG,
            (data: GeneralSignalRResponse) => {
                this.signalRService.setSender(data.userID);
                switch (data.action) {
                    case SignalRAction.Add:
                        this.store.dispatch(new AcceleratorCatalogActions.AcceleratorCatalogCreate(data.obj));
                        break;

                    case SignalRAction.Update:
                        this.store.dispatch(new AcceleratorCatalogActions.AcceleratorCatalogUpdate(data.id, data.obj));
                        break;

                    case SignalRAction.Delete:
                        this.store.dispatch(new AcceleratorCatalogActions.AcceleratorCatalogDelete(data.id));
                        break;

                    case SignalRAction.Get:
                        this.store.dispatch(new AcceleratorCatalogActions.AcceleratorCatalogRefresh());
                        break;

                    case SignalRAction.RequestRefresh:
                        this.store.dispatch(new AcceleratorCatalogActions.AcceleratorCatalogRefreshByID(data.id));
                        break;
                }
            },
        );
    }
}
